export default class ResourcesDispatcher {
    static loadResources(spines, atlas, sounds, game_constants) {
        this._SPINES = spines;
        this._ATLAS = atlas;
        this._SOUNDS = sounds;
        this._GAME_CONSTANTS = game_constants;
        console.log("Resources loaded into ResourcesDispatcher");
    }
    static get SPINES() {
        return this._SPINES;
    }
    static get ATLAS() {
        return this._ATLAS;
    }
    static get SOUNDS() {
        return this._SOUNDS;
    }
    static get GAME_CONSTANTS() {
        return this._GAME_CONSTANTS;
    }
}
